module.exports = __webpack_public_path__ + "img/hyu_thumbnail.624e7afb.jpg";